import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './index.styl';

export default function Skeleton({ height }) {
  return (
    <div className={styles.topLine}>
      <style jsx>{`
        .${styles.topLine}
          height ${height}px
      `}</style>
      <div className={cx('lb-skeleton', styles.item)} />
      <div className={cx('lb-skeleton', styles.item)} />
      <div className={cx('lb-skeleton', styles.item)} />
      <div className={cx('lb-skeleton', styles.item)} />
    </div>
  );
}

Skeleton.propTypes = {
  height: PropTypes.number,
};

Skeleton.defaultProps = {
  height: 30,
};
